import {
  JobAnalytics,
  JobQueueData,
  JobQueueParams,
  OrganizationAdminDetails,
  OrganizationListParams,
  OrganizationListResponse,
  Worker
} from 'types/admin';
import { axiosInstance } from 'utils/AxiosInstance';
import { API_PATHS } from 'utils/constants';

export const getJobQueueData = async (params: JobQueueParams = {}): Promise<JobQueueData> => {
  const {
    page = 1,
    limit = 100,
    sortBy = 'startedAt',
    order = 'desc',
    search = null,
    startDate = null,
    endDate = null,
    status = null
  } = params;

  const response = await axiosInstance.post('/admin/jobs', {
    page,
    limit,
    sortBy,
    order,
    search,
    startDate,
    endDate,
    status
  });
  return response.data;
};

export const getAllJobAnalytics = async (): Promise<JobAnalytics> => {
  const response = await axiosInstance.get('/analytics/jobs');
  return response.data;
};

export const getWorkerStats = async (): Promise<Worker[]> => {
  const response = await axiosInstance.get('/analytics/workers');
  return response.data;
};

export const getOrganizationLists = async ({
  page = 1,
  pageSize = 20,
  sortOrder = 'asc',
  sortBy = 'company_name',
  search = null,
  searchType = null
}: OrganizationListParams = {}) => {
  const response = await axiosInstance.post(API_PATHS.ADMIN_GET_ORGANIZATIONS_LIST, {
    page,
    pageSize,
    sortOrder,
    sortBy,
    search,
    searchType
  });
  return response.data;
};



export const getAdminOrganizationListsOptimized = async (params: OrganizationListParams): Promise<OrganizationListResponse> => {
  const response = await axiosInstance.post('/admin/organizations/list-organization-optimized', {
    page: params.page,
    pageSize: params.pageSize, 
    sortOrder: params.sortOrder,
    sortBy: params.sortBy,
    search: params.search,
    searchType: params.searchType,
    period: params.period
  });
  return response.data;
};

export const getOrganizationListsCSV = async () => {
  const response = await axiosInstance.get(API_PATHS.ADMIN_GET_ORGANIZATIONS_CSV);
  return response.data;
};

export const getIdfDownloadLogsCSV = async () => {
  const response = await axiosInstance.get(API_PATHS.ADMIN_GET_IDF_DOWNLOAD_LOGS_CSV, {
    responseType: 'blob',
  });
  return response.data;
};

export const getOrganizationAdminDetails = async (organizationId: string, period: 'month' | 'semester' | 'quarter' | 'year' | 'week' | 'two_weeks' = 'month' ): Promise<OrganizationAdminDetails> => {
  const response = await axiosInstance.get(`${API_PATHS.ADMIN_GET_ORGANIZATION_ADMIN_DETAILS}/${organizationId}/admin-details?period=${period}`);
  return response.data;
};

export const getOrganizationTransactionsCSV = async (organizationId: string, query?: any) => {
  const response = await axiosInstance.get(
    `${API_PATHS.GET_ORGANIZATION_TRANSACTIONS}/${organizationId}/transactions`,
    query
  );
  return response.data;
};

export const getAllTransactions = async (query: {
  page?: number;
  pageSize?: number;
  sortOrder?: 'asc' | 'desc';
  sortBy?: string;
  revisionId?: string;
  projectId?: string;
}) => {
  const response = await axiosInstance.post('/admin/transactions', query);
  return response.data;
};

export const getAllTransactionsCSV = async (query?: {
  revisionId?: string;
  projectId?: string;
}) => {
  const response = await axiosInstance.post('/admin/transactions/csv', query, {
    responseType: 'blob'
  });
  return response.data;
};





